import HttpService from '@/services/HttpService';
import { error } from '@/utils/error';
import { CLIENT_CONTROLLER } from '@/constants';
const getPaymentDetails = async () => {
    const path = `/clientcontroller/salesfunnelclient/getbetaalgegevens`;
    const { data } = (await HttpService.get(path));
    if (data.IsSucces === false) {
        error(CLIENT_CONTROLLER.FAILED_RESPONSE, {
            path
        });
    }
    return data;
};
const getLoginInfo = async () => {
    const path = `/clientcontroller/salesfunnelclient/ophalenlogininfo`;
    const { data } = (await HttpService.get(path));
    return data;
};
const getPolicyTerms = async (payload) => {
    const path = `/clientcontroller/salesfunnelclient/GetPolicyTerms`;
    const { data } = (await HttpService.post(path, payload));
    if (!data) {
        error(CLIENT_CONTROLLER.FAILED_RESPONSE, {
            path
        });
    }
    return data;
};
export default {
    getPaymentDetails,
    getLoginInfo,
    getPolicyTerms
};
